import {UUID} from '../../graphql/uuid';
import {
  DocumentGroup,
  DocumentUploadPlanNumberStatus,
} from '../../schema-types/globalTypes';

export interface FileUploadFormValues {
  datePicker: string | null;
  contactName1: string;
  contactId1: string | null;
  documentGroup: DocumentGroup | null;
  files: File[];
  notes: string;
  notification: boolean;
  // conditional fields
  planNumber?: UUID;
  providerId?: string;
  contactName2?: string;
  contactId2?: string | null;
  taxYear?: string | null;
  planNumberStatus: DocumentUploadPlanNumberStatus;
}

export const initialFileUploadFormValues: FileUploadFormValues = {
  datePicker: null,
  contactName1: '',
  contactId1: null,
  documentGroup: null,
  files: [],
  notes: '',
  notification: false,
  contactName2: '',
  contactId2: null,
  planNumber: undefined,
  providerId: '',
  taxYear: null,
  planNumberStatus: DocumentUploadPlanNumberStatus.PLAN_NUMBER_NOT_NEEDED,
};
